import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./AddressFinderHome.html');
import "../AddressFinder/AddressFinderTypes";
import AddressWizard from '../AddressWizard/AddressWizard';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import AddressView from './AddressView';

class AdressFinderHome extends compose(FinderBaseV2) {
    //templateString = template; // nur falls nötig ein eigenes laden!

    private tableFormatter(cell: StaticTable.StaticTableCell<any>) {

        //cell.contentnode.innerHTML = cell.value;

        switch (cell.name) {
            case "note":
                if (cell.value == "" || cell.value == null) {
                    this.UiModder.domClass.add(cell.tableRow.node, "w3-hide");
                }
                return true;
                break;

            default:
                return false;
                break;
        }

        //console.debug("address tableFormatter", cell);
        if (cell.value == null || cell.value == "") {
            cell.contentnode.innerHTML = "/";
            this.UiModder.domClass.add(cell.contentnode, "w3-disabled italic");
        }

    }

    private onCreateNew() {
        let form = new AddressWizard();
        form.startup();

        if (this.isEmbeddedInTab) {
            let name = "newAddress-" + (Math.random() * 100000).toFixed(0).toString();
            let tabConfig: Tabbing.TabPageDescriptor = {
                enableClosing: true,
                label: this.translations["Addresses__CreateNew"],
                name: name,
                sidebarEntryName: name,
                widget: form,
                groupLabel: this.translations["Addresses__CreateNew"],
                //coloration: "w3-blue"
            };

            this.requestNewTabbedContent(tabConfig);

            this.requestTabswitch(tabConfig.name);

            return;

        }
        let dlg = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.closeOnEscape = false;
        dlg._setHeaderAttr(this.translations["Addresses__CreateNew"]);
        //dlg.setUserdefinedButton(this.translations["General_Save"], this.translations["Addresses__CreateNew"], lang.hitch(this, this._onCloseDetailsDlg_Callback, dlg, form))
        dlg._setCloseBtnAttr(true);
        dlg.enableContentOverflow(true);
        //dlg._setCallbackAttr(lang.hitch(this, this._onCloseDetailsDlg_Callback, dlg, form))
        dlg.show();
        dlg.addNodeToContent(form.domNode);
    }

    private _onClick_Row(data: StaticTable.StaticTableRow<AddressFinderEntity>) {

        let id = null;
        let entity: AddressFinderEntity = data.rowGroup.entity;
        let label = "";
        id = entity.ID;


        if (!id) return;
        //fuegt ein email button hinzu, falls eine email im datensatz gesetzt ist  
        let addMailButtonWithAddress = "";
        try {
            if ((entity.ref_vw_telecom_addresses.emailaddress !== null) || (typeof entity.ref_vw_telecom_addresses.emailaddress === 'undefined') || (entity.ref_vw_telecom_addresses.emailaddress !== "")) {
                addMailButtonWithAddress = entity.ref_vw_telecom_addresses.emailaddress;
            }
        } catch {
            addMailButtonWithAddress = "";
        }

        let view = new AddressView();
        view.showAsDlg(id, entity.gDisp_Name_Firstname, this.getTabContainerName());

        view.on("change", lang.hitch(this, this.reload));
        view.on("deleted", lang.hitch(this, this.reload));

    }

    protected _onTableCreated(table: MdsLax<InstanceType<typeof StaticTable>>) {
        //    table.showIndexColumn = true;
        //    table.indexOffset = this._getOffsetFromPage(this._currentPage);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";


        this.finderSetup({
            configUrl: "AddressFinder/GetFilterpanelOptions",
            filterdataUrl: "AddressFinder/GetAddressList",
            configCallfunction: null,
            filterdataCallfunction: null,
            rowClickFunction: lang.hitch(this, this._onClick_Row),
            tableFormatterFunction: lang.hitch(this, this.tableFormatter),
            newEntryParams: {
                neededUserRole: "Addresses_Create",
                callback: lang.hitch(this, this.onCreateNew)
            },
            labelProperty: "gDisp_1",
            showIndexColum: true

        });

        this.addSubscription("AddressFinder/RequestNew", lang.hitch(this, this.onCreateNew));
        this.addSubscription("AddressFinder/OpenEntity", lang.hitch(this, this._onClick_Row));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles(this.translations["AddressFinder__MainTitle"], this.translations["AddressSection__MainTitle"]);

    }
}

export default mdsWidget(AdressFinderHome);
